// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] + "-" + {"125":"a703eabeb754d86da907","293":"2fec80ddd616e6f32751"}[chunkId] + ".js";
};